
import { mapState, mapActions, mapMutations } from "vuex";
import draggable from "vuedraggable";
import batchSettingsDialog from "../dialogs/batch-settings-dialog.vue";
import ConfirmationDialog from "../dialogs/confirmation-dialog.vue";
import CreateEditCategoryDialog from "../dialogs/create-edit-category-dialog.vue";
import CreateEditSubCategoryDialog from "../dialogs/create-edit-sub-category-dialog.vue";
import DeleteCategoryDialog from "../dialogs/delete-category-dialog.vue";
export default {
  components: {
    draggable,
    batchSettingsDialog,
    CreateEditCategoryDialog,
    CreateEditSubCategoryDialog,
    ConfirmationDialog,
    DeleteCategoryDialog
  },
  data() {
    return {
      groups: [
        // {
        //   type: "batch",
        //   label: "Item Batch"
        // },
        { type: "category", label: "Item Category" },
        { type: "dish", label: "Dish Type" },
        { type: "charges", label: "Other Charges" }
        // { type: "tags", label: "Tags" }
      ],
      itemBatch: [""],
      panel: "",
      subPanel: "",
      showBatchSettingsDialog: false,
      showCategoryDialog: false,
      showDeleteCategoryDialog: false,
      showSubCategoryDialog: false,
      showDeleteSubCategoryDialog: false,
      selectedCategory: {},
      selectedSubCategory: {},
      deleteLoading: false,
      dragging: false,
      draggingSubCategory: false
    };
  },
  props: {
    selectedGroupBy: "",
    selectedGroupByItem: "",
    selectedGroupBySubItem: "",
    groupedItems: []
  },
  computed: {
    ...mapState("menu", ["categories", "menuUploadList"]),
    isDraggable() {
      return this.selectedGroupBy == "category";
    }
  },
  watch: {
    panel(val) {
      if (Number.isInteger(val)) {
        this.$emit("selectedgroupByChange", this.groups[val].type);
      }
    }
  },
  beforeMount() {
    this.getCategories();
    this.getTaxes();
    this.getTags();
  },
  created() {
    if (this.selectedGroupBy) {
      this.panel = this.groups.findIndex((group) => {
        return group.type == this.selectedGroupBy;
      });
    } else {
      this.panel = 0;
    }
  },
  methods: {
    ...mapActions("menu", [
      "getCategories",
      "getTaxes",
      "getTags",
      "deleteCategory",
      "deleteSubCategory"
    ]),
    ...mapMutations("menu", ["SET_MENU_UPLOAD_LIST_PROP"]),

    handleCatogoryChange(val) {
      this.$emit(" selectedgroupByChange", this.groups[val].type);
    },
    getCategoryCount(category) {
      if (category) {
        if (category.items) {
          return category.items.length;
        } else if (category.subcategories) {
          // let count = 0;
          // category.subcategories.forEach((element) => {
          //   count += Number(this.getCategoryCount(element.subcategories));
          // });
          // return category.subcategories.reduce((count, subcategory) => {
          //   return count + (subcategory.items ? subcategory.items.length : 0);
          // });
          return category.subcategories.reduce(
            (count, subcategory) =>
              count + (subcategory.items ? subcategory.items.length : 0),
            0
          );
        }
      }
    },
    handleAddCategory() {
      this.selectedCategory = {};
      this.showCategoryDialog = true;
    },
    handleUpdateCategory(item) {
      this.selectedCategory = item;
      this.showCategoryDialog = true;
    },
    handleDeleteCategory(item) {
      this.selectedCategory = item;
      this.showDeleteCategoryDialog = true;
    },
    handleAddSubCategory(item) {
      this.selectedSubCategory = {};
      this.selectedCategory = item;
      this.showSubCategoryDialog = true;
    },
    handleUpdateSubCategory(item, parentItem) {
      this.selectedSubCategory = item;
      this.selectedCategory = parentItem;
      this.showSubCategoryDialog = true;
    },
    handleDeleteSubCategory(item, parentItem) {
      this.selectedSubCategory = item;
      this.selectedCategory = parentItem;
      this.showDeleteSubCategoryDialog = true;
    },
    async triggerDeleteCategory(data) {
      this.deleteLoading = true;
      if (data.selectedOption === "deleteAndMove") {
        this.moveItemsToCategory(data.selectedCategory);
      }
      await this.getCategoryDeleted(this.selectedCategory);
      this.deleteLoading = false;
      this.showDeleteCategoryDialog = false;
    },
    async triggerDeleteSubCategory() {
      this.deleteLoading = true;
      try {
        await this.deleteSubCategory({
          categoryId: this.selectedCategory.id,
          subCategoryId: this.selectedSubCategory.id
        });
        await this.getCategories({ forceFetch: true });
        this.$nuxt.$emit("show-toast", {
          text: "Subcategory removed successfully",
          color: "success darken-2",
          icon: "done",
          flat: true
        });
      } catch (err) {
        this.$nuxt.$emit("show-error-toast", err);
      }
      this.deleteLoading = false;
      this.showDeleteSubCategoryDialog = false;
    },
    dragChange(val) {}
  }
};
